<template>
  <div>
    <a-title
      :text="$t('reporting.cpvChecks')"
    />
    <l-rows>
      <l-rows-row content-position="right">
        <a-button
          :text="$t('reporting.checkComponents')"
          variant="primary"
          @click="handleCheck"
        />
      </l-rows-row>
      <o-list
        class="has-word-break-all"
        :data="page.cpvChecks"
        :columns="columns"
        :loading="pageMeta.loading"
        :limit="limit"
        :offset="offset"
        :total="page.totalCount"
        @page-change="handlePageChange"
      />
    </l-rows>
  </div>
</template>

<script>
  import { AButton, ATitle, LRows, LRowsRow, OList } from 'codefabrik-gui-vue'
  import { reportingService } from '@/services'
  import useQuery from 'codefabrik-gui-vue/src/apollo/mixins/useQuery'
  import { formatDateTime } from '@/shared'

  export default {
    name: 'CPVCheckList',
    components: { ATitle, LRows, OList, AButton, LRowsRow },
    data () {
      return {
        offset: 0,
        limit: 0
      }
    },
    methods: {
      handleCheck () {
        this.$router.push({ name: 'cpv-check-trigger' })
      },
      handlePageChange (pageNumber) {
        this.offset = (pageNumber - 1) * this.limit
      },
    },
    computed: {
      columns () {
        return [
          {
            header: this.$t('common.checkedOn'),
            field: 'date',
            filter: formatDateTime
          },
          {
            header: this.$t('common.component'),
            field: 'component',
          },
          {
            header: this.$t('common.hash'),
            field: 'hash',
          },
          {
            header: this.$t('common.allowedHashes'),
            field: 'hashAllowList',
          },
          {
            header: this.$t('common.result'),
            field: 'result',
          },
        ]
      }
    },
    mixins: [useQuery({
      name: 'page',
      serviceFn: reportingService.getCPVChecks,
      variables () {
        return {
          input: {
            limit: this.limit,
            offset: this.offset
          }
        }
      }
    })]
  }
</script>

<style scoped>
  .has-word-break-all {
    word-break: break-all;
  }
</style>
